module.exports = __webpack_public_path__ + "media/background-home-proposals.f59a1717.mp4";